<div *ngIf="isLoading">
  <po-loading-overlay [p-text]="'Carregando...'" [p-size]="'sm'"></po-loading-overlay>
</div>
<app-toaster></app-toaster>
<po-page-default class="count-items-wrapper">
  <div class="po-page-wrapper">
    <div class="po-row po-mb-2 po-mt-2 po-flex" style="justify-content: space-between; align-items: center;">
      <p class="po-font-title" style="font-size: 18px; font-weight: 600;">Contagem Movimentação OP</p>

      <po-button p-label="Voltar" p-kind="secondary" (p-click)="goBack()">
      </po-button>
    </div>

    <div class="header-section">
      <div class="po-row">
        <div class="po-xs-12 po-sm-12 po-md-12 po-lg-12 po-xl-12">
          <po-info [p-orientation]="PoInfoOrientation.Horizontal" p-label="Contagem"
            [p-value]="countDetails.code"></po-info>
          <po-info [p-orientation]="PoInfoOrientation.Horizontal" p-label="Local Origem"
            [p-value]="countDetails.originLocation.displayLabel"></po-info>
          <po-info [p-orientation]="PoInfoOrientation.Horizontal" p-label="Local Destino"
            [p-value]="countDetails.destinationLocation.displayLabel"></po-info>
        </div>
      </div>

      <div class="po-row">
        <div class="po-xs-6 po-sm-6 po-md-6 po-lg-6 po-xl-6">
          <po-info [p-orientation]="PoInfoOrientation.Horizontal" p-label="Quantidade"
            [p-value]="countDetails.quantity"></po-info>
        </div>
        <div class="po-xs-6 po-sm-6 po-md-6 po-lg-6 po-xl-6" *ngIf="countDetails.pack > 0">
          <po-info [p-orientation]="PoInfoOrientation.Horizontal" p-label="Pack" [p-value]="countDetails.pack"
            p-type="info"></po-info>
        </div>
      </div>
    </div>


    <hr class="hr-divider">
    <po-input id="barcodeInput" #barcodeInput name="barcodeInput" class="po-xs-6" p-label="Barras:"
      [(ngModel)]="barCode" p-icon="an an-barcode" p-icon-click="onScan()" (keyup.enter)="onScan()"
      (keydown.tab)="onScan(); $event.preventDefault()">
    </po-input>
    <hr class="hr-divider">
    <div class="scroll-area">
      <div *ngFor="let item of countDetails.items">
        <div class="po-row po-mb-2 po-align-items-center item-card">

          <div class="po-xs-10 po-sm-10 po-md-10 item-content">

            <div class="info-line"><strong>Sequência:</strong> {{ item.sequence }}</div>
            <div class="info-line"><strong>Barra:</strong> {{ item.barCode }}</div>
            <div class="info-line">
              <strong>OP:</strong>
              {{ item.productionOrderBranchCode }} - {{ item.productionOrderCycleCode }} - {{
              item.productionOrderCode}}
            </div>

            <div class="info-row">
              <span class="half"><strong>Prod:</strong> {{ item.productCode }}</span>
              <span class="half"><strong>Qt:</strong> {{ item.quantity }}</span>
            </div>


            <div class="info-line"><strong>Desc:</strong> {{ item.descriptionProduct }}</div>
          </div>

          <div class="po-xs-1 po-sm-1 po-md-1 po-text-right">
            <po-button p-icon="an an-x-circle" p-size="large" p-kind="tertiary" (p-click)="removeItem(item.sequence)"
              class="icon-button">
            </po-button>
          </div>

        </div>

      </div>
    </div>

  </div>


</po-page-default>